import { Button, styled } from "@mui/material";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";

export const StyledPickersButtonField = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "isActive",
})<{
  isSelected?: boolean;
  isActive?: boolean;
}>`
  &&& {
    height: ${({ theme }) => theme.wsc.size.l};
    padding: 0 ${({ theme }) => theme.wsc.spacing[0]};
    min-width: auto;
    outline: none !important;
    border-radius: ${({ theme }) => theme.wsc.radius.sm};
    ${(props) =>
      !props.isSelected &&
      !props.isActive &&
      `
			color: ${props.theme.wsc.palette.neutral[100]};
	
			&:hover {
				color: ${props.theme.wsc.palette.neutral[200]};
				background: none;
			}
		`}

    ${(props) =>
      props.isActive &&
      !props.isSelected &&
      `
			color: ${props.theme.wsc.palette.neutral[100]};
		
			&:hover {
				color: ${props.theme.wsc.palette.primary[100]};
				background-color: ${props.theme.wsc.palette.neutral[500]};
			}
		`}

		${(props) =>
      props.isSelected &&
      `
			color: ${props.theme.wsc.palette.primary[500]};
			background-color: ${props.theme.wsc.palette.neutral[500]};
			
			&:hover {
				background-color: ${props.theme.wsc.palette.neutral[500]};
			}
		`}

		&.Mui-disabled {
      color: ${(props) =>
        props.isActive
          ? props.theme.wsc.palette.primary[700]
          : props.theme.wsc.palette.neutral[400]};
    }
  }
`;

export const StyledArrowDropDownIcon = styled(ArrowDropDownIcon)`
  font-size: ${(props) => props.theme.wsc.size.m};
`;

export const StyledCircle = styled("span", {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "isDisabled",
})<{
  isSelected?: boolean;
  isDisabled?: boolean;
}>`
  margin-top: ${({ theme }) => theme.wsc.spacing[0]};
  width: 0.214rem;
  height: 0.214rem;
  border-radius: ${(props) => props.theme.wsc.radius.half};
  align-self: flex-start;
  background-color: ${(props) =>
    props.isDisabled
      ? ` ${props.theme.wsc.palette.primary[700]};
	`
      : `
		${
      props.isSelected
        ? props.theme.wsc.palette.primary[500]
        : props.theme.wsc.palette.primary[300]
    };
	`};
`;
